module.exports = __webpack_public_path__ + "img/139-british columbia.f396f49e.svg";